import React, { useEffect, useState } from "react";
import { ImportDataType } from "../partnerIntegrationService";
import ImportDetailsProps from "./importDetailsProps";
import { Form } from "react-bootstrap";
import DateRangePicker from "common/ui/DateRangePicker";
import ErrorList from "common/ui/ErrorList";

const dataTypes = [
    { name: "Contracts", type: ImportDataType.Contract },
    { name: "Customers", type: ImportDataType.Account },
    { name: "Commodity Balances", type: ImportDataType.CommodityBalance },
    { name: "Scale Tickets", type: ImportDataType.ScaleTicket },
    { name: "Settlements", type: ImportDataType.Settlement },
];

export const ImportByDateDetails: React.FC<ImportDetailsProps> = props => {

    const [errors, setErrors] = useState<string[]>(null);

    useEffect(() => {
        props.onIsValidChanged(isValid());
    }, [props.request]);

    function toggleRecordType(type: ImportDataType, enabled: boolean) {
        const newDataTypes = enabled
            ? [...props.request.dataTypes, type]
            : props.request.dataTypes.filter(m => m !== type);
        props.onChange({...props.request, dataTypes: newDataTypes});
    }

    function isValid(): boolean {
        if (props.request.importBeforeDate == null && props.request.importAfterDate == null) return false;
        if (props.request.importBeforeDate != null && props.request.importAfterDate != null && props.request.importBeforeDate < props.request.importAfterDate) return false;
        if (props.request.dataTypes.length === 0) return false;

        return true;
    }

    return <>
        <p>System will retry importing the selected records from Cosmos that were last synced between the given dates.</p>
        <div>
            <strong>Record Types:</strong>

            <div className="pl-4">
                {dataTypes.map((dt, i) => <Form.Check
                    key={i}
                    name="byDateRecordTypes"
                    id={"byDateRecordTypes" + i}
                    label={dt.name}
                    checked={props.request.dataTypes.includes(dt.type)}
                    onChange={ev => toggleRecordType(dt.type, ev.target.checked)}
                />)}
            </div>
        </div>
        <div>
            <strong>Between Dates:</strong>

            <span className="pl-2">
                <DateRangePicker inline
                    startDate={props.request.importAfterDate}
                    endDate={props.request.importBeforeDate}
                    maxStartDate={new Date()}
                    onRangeChanged={(start, end) => props.onChange({...props.request, importBeforeDate: end, importAfterDate: start})}
                    onValidationErrors={errs => {
                        setErrors(errs);
                        props.onIsValidChanged(false);
                    }} />
                <ErrorList errors={errors} />
            </span>
        </div>
    </>;
}

export const ImportSpecificRecordsDetails: React.FC<ImportDetailsProps> = props => {

    useEffect(() => {
        props.onIsValidChanged(isValid());
    }, [props.request]);

    function toggleRecordType(type: ImportDataType, enabled: boolean) {
        const newDataTypes = enabled
            ? [type]
            : [];
        props.onChange({...props.request, dataTypes: newDataTypes});
    }

    function isValid(): boolean {
        if (props.request.dataTypes.length !== 1) return false;
        if (props.request.recordIds.length === 0) return false;
        return true;
    }

    return <>
        <p>System will retry importing the records from Cosmos that match the given IDs.</p>
        <div>
            <strong>Record Type:</strong>

            <div className="pl-4">
                {dataTypes.map((dt, i) => <Form.Check
                        key={i}
                        type="radio"
                        name="specificRecordsType"
                        id={"specificRecordsType" + i}
                        label={dt.name}
                        checked={props.request.dataTypes.includes(dt.type)}
                        onChange={ev => toggleRecordType(dt.type, ev.target.checked)}
                />)}
            </div>
        </div>

        <div>
            <strong>Record IDs (one per line):</strong>
        </div>
        <div>
            <textarea className="form-control" rows={5} 
                value={props.request.recordIds.join('\n')}
                onChange={ev => props.onChange({...props.request, recordIds: ev.target.value.split('\n')})}>
            </textarea>
        </div>
    </>;
}
